// Simple publish/subscribe event bus
(function() {
const subscribers = {};

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) subscribers[eventName] = [];
  subscribers[eventName] = [...subscribers[eventName], callback];
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => callback(data));
  }
}

window.PubSub = { subscribe, publish, EVENTS: PUB_SUB_EVENTS };
})();
